export default "__VITE_ASSET__CoJpjwdY__"